import React from 'react';
import { COLORS } from '../../../styles/emotion';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

export const ContentAlignmentIcon = ({
  title = 'ContentAlignment',
  ...props
}: CreateIconComponentProps): JSX.Element => (
  <CreateIconComponent title={title} viewBox="0 0 24 24" {...props} fill={COLORS.WHITE}>
    <path
      d="M12 20V4"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect
      x="3"
      y="18"
      width="12"
      height="5"
      rx="2"
      transform="rotate(-90 3 18)"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect
      x="16"
      y="18"
      width="12"
      height="5"
      rx="2"
      transform="rotate(-90 16 18)"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </CreateIconComponent>
);

export default ContentAlignmentIcon;
